module.exports = __webpack_public_path__ + "img/360-lager-1.c08dc1db.jpg";